import shopifyEnterpriseGeneric from '../shopify-enterprise-generic/config.js';

const wheelsFields = ['wheel_tire_diameter', 'wheel_width', 'wheel_bolt_pattern_mm'];
const tiresFields = ['tire_width', 'tire_aspect', 'wheel_tire_diameter'];

const ignoreFields = [...wheelsFields, ...tiresFields, 'tire_size'];

const AutoSyncKey = 'xbpth0-pi';

const isOnPackagesPage = window.location.pathname === '/collections/mounted-packages';

window.Convermax.mountedPackagesAddToCartWithRedirect = (productId, variantId, fitmentType) => async (e) => {
  e.preventDefault();
  e.stopPropagation();

  const { href } = window.location;

  const isTire = fitmentType.includes('Tire');

  const redirectPath =
    href.includes('lastStep') || href.includes('WheelProductID') || isTire
      ? '/cart'
      : `/collections/fastco-tires/?WheelProductID/${productId}/${window.Convermax.getVehicleSearchParams()}`;

  if (!redirectPath) {
    return;
  }

  const cartUrls = window.Convermax.Shopify.getCartUrls();
  const verifyFitmentVehicle = window.document.querySelector('.cm_verify-message-property')?.value;

  const bodyForm = {
    items: [
      {
        id: variantId,
        quantity: 4,
        properties: {
          ['Fitment']: verifyFitmentVehicle ?? 'The vehicle has not been selected',
        },
      },
      isTire && { id: 50794665083096, quantity: 1 }, // 50794665083096 - Mounting And Balancing (X4)
    ].filter(Boolean),
  };

  fetch(`${cartUrls.add}.js`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(bodyForm),
  })
    .then((response) => {
      if (response.ok) {
        window.location.replace(redirectPath);
      } else {
        // check if the cart is already contains this product
        fetch(`${cartUrls.root}.js`, {
          method: 'GET',
          headers: { 'Content-Type': 'application/json' },
        })
          .then((response) => response.json())
          .then((response) => {
            if (response.items?.some((i) => i.variant_id === +variantId)) {
              window.location.replace(redirectPath);
            } else {
              console.error(response);
            }
          })
          .catch((e) => {
            console.error(e);
          });
      }
    })
    .catch((e) => {
      console.error(e);
    });
};

function onVerifyFitmentResponseReceived(response) {
  const packageButton = window.document.querySelector('#cm-package-button');
  const addToCartButton = window.document.querySelector('.product-info__add-button');

  if (!response.Items || !packageButton) {
    return;
  }

  // eslint-disable-next-line camelcase
  const [{ id, variant_ids, fitsTheVehicle, FitmentType }] = response.Items;

  if (fitsTheVehicle === 'yes') {
    const isWheel = FitmentType.includes('Wheel');
    const isTire = FitmentType.includes('Tire');
    const isLastStep = window.location.href.includes('lastStep');

    packageButton.style.display = 'block';
    packageButton.querySelector('button').innerText =
      (isWheel || isTire) && !isLastStep
        ? `${isWheel ? 'Select and Proceed to Tires' : 'Select and Proceed to Cart'} `
        : isLastStep
          ? 'Select and Proceed to Cart'
          : 'Get as Package';
    packageButton.addEventListener('click', async (e) => {
      // eslint-disable-next-line camelcase
      window.Convermax.mountedPackagesAddToCartWithRedirect(id, variant_ids[0], FitmentType)(e);
    });

    if (addToCartButton) {
      addToCartButton.style.display = 'none';
    }
  } else {
    packageButton.style.display = 'none';

    if (addToCartButton) {
      addToCartButton.style.display = 'block';
    }
  }
}

export default {
  ...shopifyEnterpriseGeneric,
  includes: ['shopify-enterprise-generic'],
  SearchRequestDefaults: {
    ...shopifyEnterpriseGeneric.SearchRequestDefaults,
    extra: {
      ...shopifyEnterpriseGeneric.SearchRequestDefaults.extra,
      doNotHideWheelsTiresFacets: window.location.pathname === '/',
    },
  },
  fitmentSearch: {
    ...shopifyEnterpriseGeneric.fitmentSearch,
    forceVehicleSelection: isOnPackagesPage,
    onVerifyFitmentResponseReceived,
    onVerifyFitmentInitResponseReceived: onVerifyFitmentResponseReceived,
  },
  Widgets: [
    ...shopifyEnterpriseGeneric.Widgets.filter(
      (w) => !['FacetBarWheels', 'FacetBarTires', 'FilterChips', 'Facets', 'VerifyFitment'].includes(w.name),
    ),

    {
      name: 'HomeVehicleWidget_tab',
      type: 'VehicleWidget',
      location: '#vehicle-filter',
      template: 'fitmentSearch/homeVehicleWidget',
      isVehicleSelectionIsolated: true,
      columnBreakpoint: 700,
    },
    {
      name: 'WheelPanel_tab',
      type: 'RequestPanel',
      location: '#wheel-filter',
      template: 'HomeWheelTireBar',
      needInitRequest: true,
      redirectUrl: '/collections/wheels',
      selectFields: wheelsFields,
    },
    {
      name: 'TirePanel_tab',
      type: 'RequestPanel',
      location: '#tire-filter',
      template: 'HomeWheelTireBar',
      needInitRequest: true,
      redirectUrl: '/collections/tires',
      selectFields: tiresFields,
    },
    {
      name: 'FacetBarWheels',
      type: 'FacetBar',
      fields: wheelsFields,
      minFacetCount: 2,
    },
    {
      name: 'FacetBarTires',
      type: 'FacetBar',
      fields: tiresFields,
      minFacetCount: 2,
    },
    {
      name: 'FilterChips',
      type: 'FacetPanel',
      ignoreFields,
    },
    {
      name: 'Facets',
      type: 'FacetPanel',
      ignoreFields,
      initCollapsed: true,
    },
    {
      name: 'UpsizeDownsizeFacetPanel',
      type: 'FacetPanel',
      fields: ['wheel_tire_diameter', 'tire_size'],
      showAllAlways: true,
      disableCollapse: true,
    },
    {
      name: 'WheelTireVehicleInfo',
      autoSyncVisualization: {
        apiKey: AutoSyncKey,
      },
    },
    {
      name: 'AutoSyncVisualizationDialog',
      apiKey: AutoSyncKey,
      template: 'fitmentSearch/autoSyncVisualizationDialog',
    },
    {
      name: 'VerifyFitment',
      location: '#cm-verify-fitment',
      template: 'fitmentSearch/verifyFitment',
      columnBreakpoint: 400,
    },
  ],
};
